/**
 * Drops plain `$autocapture` events on their way to PostHog, keeping everything autocapture exists for here.
 *
 * `$autocapture` was ~59% of billed events (~1.1M/month) and no insight or action read it. It cannot simply be
 * turned off with `autocapture: false`: posthog-js (1.417) detects `$rageclick` inside the autocapture click
 * handler, so disabling autocapture silently kills rage clicks too, and those are wanted. So the SDK keeps
 * listening and this `before_send` hook discards the generic click/change/submit events. A dropped event is
 * never sent, so it is never billed.
 *
 * Kept: `$rageclick` (a separate event name), heatmaps (`$$heatmap`, gated on `capture_heatmaps` alone),
 * `$pageview`, and every named event. Lost: after-the-fact analysis of clicks nobody instrumented, and the
 * toolbar's autocapture-based click-map overlay. Instrument a click with `AnalyticsService.track` instead.
 */
export function dropAutocaptureEvents<T extends { event?: string } | null>(captureResult: T): T | null {
  return captureResult?.event === '$autocapture' ? null : captureResult;
}
